import styled from 'styled-components';
import { Button as RBButton } from 'react-bootstrap';

/**
 * StyledButton
 * - React-Bootstrap props like `variant`, `size`, `disabled` still work
 * - Unknown props are blocked from leaking to DOM
 * - Custom props use `$` prefix (transient props)
 */

export const StyledButton = styled(RBButton).withConfig({
  shouldForwardProp: (prop) =>
    !["$rounded", "$customColor"].includes(prop) // block only transient props
})`
  /* Default radius, or pill if $rounded is true */
  border-radius: ${({ $rounded }) =>
    $rounded
      ? "50px"
      : "var(--cdv-radius-btn, var(--bs-btn-border-radius, .25rem))"};

  /* If you pass $customColor, override Bootstrap bg */
  ${({ $customColor }) =>
    $customColor &&
    `
    background-color: ${$customColor} !important;
    border-color: ${$customColor} !important;
  `}

  /* Link variant parity */
  &&.btn-link {
    background: transparent;
    border: 0;
    padding: 0;
    color: var(--bs-link-color);
    text-decoration: var(--bs-link-decoration, underline);
    text-underline-offset: 0.1875rem;

    &:hover,
    &:focus {
      color: var(--bs-link-hover-color);
      text-decoration: var(--bs-link-hover-decoration, underline);
      box-shadow: none;
    }

    &:disabled,
    &.disabled {
      color: var(--bs-btn-disabled-color);
      text-decoration: none;
      pointer-events: none;
    }
  }

  &&:not(.btn-link) {
    color: ${({ theme }) => theme?.colors?.btnText || "#fff"} !important;
    &:focus {
      box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb, 13,110,253), 0.5);
    }
  }

  /* Sizes */
  &.btn-sm {
    border-radius: var(--bs-btn-border-radius-sm, .2rem);
  }
  &.btn-lg {
    border-radius: var(--bs-btn-border-radius-lg, .3rem);
  }
`;

export default StyledButton;
